/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateParentIntegrationRequest } from '../../models/create-parent-integration-request';
import { CreateParentIntegrationResponse } from '../../models/create-parent-integration-response';

export interface Create_3$Params {
  
    /**
     * Parent Integration to be created.
     */
    body: CreateParentIntegrationRequest
}

export function create_3(http: HttpClient, rootUrl: string, params: Create_3$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateParentIntegrationResponse>> {
  const rb = new RequestBuilder(rootUrl, create_3.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateParentIntegrationResponse>;
    })
  );
}

create_3.PATH = '/v1/organizations/parent/integration';
